export const environment = {
  production: false,
  encryption: false,
  ENCRIPTION_KEY: 'bba3c6560756c7cbbb3c04ae0ba928ac',
  ENCRIPTION_IV: 'RagHqstop2ZYrGRZ',
  // API_URL: 'https://tportal.qatch.app/booking_tool/',
  // AUTH_API: 'https://tportal.qatch.app/',
  // FILE_URL: 'http://tportal.qatch.app/',
  // SOCKET_URL: 'http://tsocket-qpartner.qatch.app/',
  API_URL: 'https://portal.qatch.app/booking_tool/',
  AUTH_API: 'https://portal.qatch.app/',
  FILE_URL: 'https://qatchnew.s3.eu-central-1.amazonaws.com/',
  SOCKET_URL: 'https://socket-qpartner.qatch.app/',
  DEFAULT_PHONE: '+31',
  powerBy: 'Qatch',
  GOOGLE_PLACES_API_KEY: '', // Add your Google Places API key here

  // Trip Api
  'Booking Tool': {
    settingDetails: 'setting_details',
    requestPayment: 'requestPayment',
    submitStripe: 'submit_stripe',
    submitIdeal: 'submit_ideal',
    tripDetails: 'trip-detail',
    cancel: 'set-trip-status',
    complete: 'completeBookingTool',
    search: 'search',
    searchAll: 'partner-list-against-price',
    create: 'create-trip',
    openQr: 'open_company_qr/',
    track: 'track',
  },
};
